var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmployeeSearch',{attrs:{"partnerId":_vm.partnerId,"routeToEmployeeCustomerService":_vm.routeToEmployeeCustomerService}})}
var staticRenderFns = []

export { render, staticRenderFns }